export default {
    // 查询托管树形接口
    findTrusteeshipTree(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/tableController/findTrusteeshipTree', params, response);
    },

    // 查询表数据信息
    queryTableDatas(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/dataController/query', params, response);
    },

    // 添加数据
    insertData(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/dataController/insert', params, response);
    },

    // 删除数据
    deleteData(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/dataController/delete', params, response);
    },

    // 更新数据
    updateData(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/dataController/update', params, response);
    },

    // 初始化添加属性信息
    initMasterDataAddPage(params, response) {
        return window.vue.$apiAxios.post('/setting/dataController/initMasterDataAddPage', params, response);
    },

    // 导入
    importData(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/dataController/importFromFile', params, response);
    },

    // 导出
    exportData(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/dataController/exportToFile', params, response);
    }
};
